<template>
    <div class="bottomMenu">
        
        
        <router-link :to="{name:'home'}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <circle cx="7.2" cy="14.4" r="3.2"/>
                <circle cx="14.8" cy="18" r="2"/>
                <circle cx="15.2" cy="8.8" r="4.8"/>
            </svg>
            <span>{{ $t("menu.explore") }}</span>
        </router-link>
        <router-link  :to="{name:'products', query:{brand: 'real'}}"  :class='{ "router-link-exact-active" : (  $route.name === "products" )}'>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024" version="1.1">
                <path d="M758.35392 293.92896c-21.40672 100.51072-76.6976 172.57984-142.11584
                    172.57984-83.93216 0-151.936-117.888-151.936-263.23968 0-70.4 16.19968-134.016
                    42.14272-181.21728C492.88704 33.408 160.43008 314.4704 160.43008 654.2848c0
                    187.06432 165.21728 338.71872 368.99328 338.71872 203.7504 0 368.96768-151.6544
                    368.96768-338.71872C898.39616 528.42496 834.39104 401.28512 758.35392 293.92896L758.35392 293.92896zM526.39232 912.04608c-237.1584 0-187.71968-405.06368-187.71968-405.06368 3.26656 37.06368 58.56256 180.00896 195.88096 180.00896 57.7024 0 134.08256 12.63616
                    146.8416 89.97888C687.7952 815.8208 650.6752 912.04608 526.39232 912.04608L526.39232 912.04608z"/>
            </svg>
            <span>{{ $t("menu.products") }}</span>
        </router-link>
        <router-link :to="{name:'recipes', query:{page_filter: 0}}" :class='{ "router-link-exact-active" : (  $route.name === "recipes" )  }'>
            
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="18" height="18" viewBox="0 0 1024 1024"
                 version="1.1">
                <path d="M768 768 1024 768 1024 1024 768 1024 768 768ZM384 768 640 768 640 1024 384 1024 384 768ZM0 768 256 768 256
                    1024 0 1024 0 768ZM768 384 1024 384 1024 640 768 640 768 384ZM384 384 640 384 640 640 384 640 384 384ZM0 384 256
                    384 256 640 0 640 0 384ZM768 0 1024 0 1024 256 768 256 768 0ZM384 0 640 0 640 256 384 256 384 0ZM0 0 256 0 256 256
                    0 256 0 0Z"/>
            </svg>
            <span>{{ $t("menu.recipes") }}</span>
        </router-link>
        <router-link :to="{name:'favorites'}">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px" y="0px" width="20" height="20" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;"
                 xml:space="preserve">
                <path
                    d="M255,489.6l-35.7-35.7C86.7,336.6,0,257.55,0,160.65C0,81.6,61.2,20.4,140.25,20.4c43.35,0,86.7,20.4,114.75,53.55
                        C283.05,40.8,326.4,20.4,369.75,20.4C448.8,20.4,510,81.6,510,160.65c0,96.9-86.7,175.95-219.3,293.25L255,489.6z"/>
            </svg>
            <span>{{ $t("menu.favorites") }}</span>
        </router-link>
        
        <!--<div class="box"></div>-->
    </div>
</template>

<script>
    export default {
        name: 'Menu',
    }
</script>
